import React, { useEffect, useState } from 'react'
import Topbar from '../components/Layout/Topbar'
import { Sidebar } from '../components/Layout/Sidebar'
import CreateBranchList from '../components/Branch/CreateBranchList'
import { supabase } from '../supabase.config'
import { useSelector } from 'react-redux'
import BranchList from '../components/Branch/BranchList'

const CreateBranch = () => {
    const { error, loading, isAuthenticated,users,userProfile } = useSelector(
        (state) => state.user
      );
    const [brandInfo, setBrandInfo] = useState({
        location:"",
        name:"",
        city:"",
        state:"",
        pincode:"",
        branchManager:"",
        phoneNumber:""
    })
    const [branchList, setBranchList] = useState([])
    const deleteWarehouse = async (id) =>{
        const { error } = await supabase
          .from('branches')
          .delete()
          .eq('id', id)
        if (error) {
          alert('Failed to delete branch: ' + error.message)
          return
        }
        setBranchList(prev => prev.filter(b => b.id !== id))
    }
    const handleBrachAdd = async () =>{
        if(brandInfo?.name.length===0){
            alert("Please enter the Pin Code")
        }
        else if(brandInfo.city.length===0){
            alert("Please enter the City name")
        }
        else if(brandInfo.state.length===0){
            alert("Please enter the State name")
        }
       
        else if(brandInfo.location.length===0){
            alert("Please enter the Address")
        }
        else if(brandInfo.branchManager.length===0){
            alert("Please enter the Branch Manager name")
        }
        else if(brandInfo.phoneNumber.length===0){
            alert("Please enter the Phone Number")
        }
       
        else{
            const payload = {
              name: brandInfo?.name,
              pin_code: brandInfo?.pincode,
              city: brandInfo.city,
              state: brandInfo.state,
              country: 'india',
              address: brandInfo.location,
              phone: brandInfo.phoneNumber,
              branch_manager: brandInfo.branchManager,
              user_id: userProfile?.id || userProfile?.uid || null
            }
            const { data, error } = await supabase
              .from('branches')
              .insert([payload])
              .select()
            if (error) {
              alert('Failed to create branch: ' + error.message)
              return
            }
            const created = data?.[0]
            // Map to UI shape expected by BranchList
            const mapped = {
              id: created.id,
              locationName: created.name,
              pinCode: created.pin_code,
              city: created.city,
              state: created.state,
              country: created.country,
              address: created.address,
              phone: created.phone,
              branchManager: created.branch_manager,
              userUid: created.user_id
            }
            setBranchList(prev => [mapped, ...prev])
            setBrandInfo({
              location:"",
              name:"",
              city:"",
              state:"",
              pincode:"",
              branchManager:"",
              phoneNumber:""
            })
        }
    }
    const fetchBranch = async () =>{
        const { data, error } = await supabase
          .from('branches')
          .select('*')
          .order('created_at', { ascending: false })
        if (error) {
          console.error('Failed to fetch branches', error)
          return
        }
        const mapped = (data || []).map(r => ({
          id: r.id,
          locationName: r.name,
          pinCode: r.pin_code,
          city: r.city,
          state: r.state,
          country: r.country,
          address: r.address,
          phone: r.phone,
          branchManager: r.branch_manager,
          userUid: r.user_id
        }))
        setBranchList(mapped)
    }
    useEffect(() => {
     fetchBranch()
    }, [])
    
  return (
    <div className='bg-gray-100 flex '>
      <Sidebar />
    <div className='h-[100vh] overflow-y-scroll flex flex-1 flex-col' >
    <Topbar />
      
        <div className='col-span-4 mx-12 my-8 bg-white rounded-lg px-12 py-6'>
   <CreateBranchList brandInfo={brandInfo} setBrandInfo={setBrandInfo} handleBrachAdd={handleBrachAdd}  />
   <BranchList branchList={branchList} setBranchList={setBranchList} />
   </div>
    </div>
    </div>
  )
}

export default CreateBranch
